import { render, staticRenderFns } from "./AdminEditPage.vue?vue&type=template&id=fec81c26"
import script from "./AdminEditPage.vue?vue&type=script&lang=js"
export * from "./AdminEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fec81c26')) {
      api.createRecord('fec81c26', component.options)
    } else {
      api.reload('fec81c26', component.options)
    }
    module.hot.accept("./AdminEditPage.vue?vue&type=template&id=fec81c26", function () {
      api.rerender('fec81c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admins/AdminEditPage.vue"
export default component.exports